/* eslint-disable @next/next/no-img-element */
import { ResourceType } from '@ds-frontend/resource'
import { Col, Row } from 'antd'
import get from 'lodash/get'

import { useTranslations } from 'common/language'
import { Container, Typography } from 'common/widgets'
import { ServiceReviewBadge } from 'common/widgets/blocks/ProductReviews'
import logoBoa from 'img/logo.svg'
import logoBoaFr from 'img/logo-fr.svg'
import classNames from './layout.module.scss'


Footer.propTypes = {
  footerData: ResourceType.isRequired,
}

export default function Footer({ footerData }) {
  const { languageCode } = useTranslations()
  const data = get(footerData, 'data')
  return (
    <footer className={classNames.quoteFooter}>
      <Container size="xl">
        <Row gutter={[0, { xs: 20 }]} justify="space-between" align="bottom">
          <Col span={24} lg={12}>
            <img
              src={languageCode === 'de' ? logoBoa : logoBoaFr}
              className={classNames.quoteLogoImage}
              alt="Boa Lingua logo"
            />
            <div>
              {
                get(data, `contacts.phone_${languageCode}`) && (
                  <div>
                    <Typography
                      variant="footer-link"
                      tag="a"
                      href={`tel:${get(data, `contacts.phone_${languageCode}`)}`}
                      className={classNames.quoteContact}
                    >
                      {get(data, `contacts.phone_${languageCode}`)}
                    </Typography>
                  </div>
                )
              }
              {
                data.contacts.email && (
                  <div>
                    <Typography
                      variant="footer-link"
                      tag="a"
                      href={`mailto:${data.contacts.email}`}
                      className={classNames.quoteContact}
                    >
                      {data.contacts.email}
                    </Typography>
                  </div>
                )
              }
            </div>
          </Col>
          <Col span={24} lg={12} className={classNames.reevooColumn}>
            <ServiceReviewBadge />
          </Col>
        </Row>
      </Container>
    </footer>
  )
}
